export default "/images/framework/HeroBarEng.bf4856f4.svg?bf4856f4";